const WindowSize = {
	LAPTOP: 1024,
	TABLET: 768,
	MOBILE: 425,
};

export default WindowSize;
